import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../../ip_api.config')

class Acc_EditMasterOption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            type: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit,
                type: this.props.location.state.type
            }, () => {
                this.get_masterStandard()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    get_masterStandard = () => {
        console.log('id', this.state.id)
        console.log('type', this.state.type)
        this.setState({ isLoading: true })
        let arr = []
        let temp

        let url = proxy.server + '/acc/getMaster_Option'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id,
                type: this.state.type
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        type: val.type,
                        code: val.code,
                        description: val.description,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => {
                    console.log("arr_save", this.state.arr_save)
                    this.preview_masterStandard()
                })
            })
    }

    preview_masterStandard = () => {
        let arr = []

        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.code} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.description} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'code') {
            this.state.arr_save[index].code = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.preview_masterStandard()
        })
    }

    update_masterStandard = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/update_Option'

            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            localStorage.setItem("type", this.state.type)

                            this.props.history.push({
                                pathname: '/Acc/MasterOption'
                            })
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >Edit Master Option</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_masterStandard()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            {/* <th>type</th> */}
                            <th>code</th>
                            <th>description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewbom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_EditMasterOption